import { render } from "./InfoText.vue?vue&type=template&id=f5fb6b04&scoped=true"
import script from "./InfoText.vue?vue&type=script&lang=js"
export * from "./InfoText.vue?vue&type=script&lang=js"

import "./InfoText.vue?vue&type=style&index=0&id=f5fb6b04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5fb6b04"]])

export default __exports__